import React from 'react';
import { useLocation } from 'react-router';

import CheckListForm from '../../Components/CheckListForm';

export default function CheckListUpdate() {
  const location = useLocation();

  return (
    <div>
      <CheckListForm updateId={location.state.ICLId} />
    </div>
  );
}
